<template>
  <div class="tooltip flex flex-col p-1 rounded-2xl shadow-md pointer-events-none">
    <div class="flex items-center gap-1 p-3">
      <CalendarIcon class="text-white" />
      <BaseText type="label" size="sm" class="text-white">
        {{ displayDate }}
      </BaseText>
    </div>
    <div class="w-full flex flex-col gap-1 p-3 rounded-xl bg-neutral-alpha-50">
      <BaseText type="body" size="sm" class="text-neutral-alpha-700">
        Credits Used
      </BaseText>
      <div class="flex items-center gap-1.5">
        <img src="../../assets/icons/api-token.png" class="w-6 h-6">
        <BaseText type="heading" size="lg" class="text-white">
          {{ creditCount?.toLocaleString() ?? 0 }}
        </BaseText>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import CalendarIcon from '../globals/Icons/CalendarIcon.vue'

export default {
  name: 'UsageGraphHoverTooltip',
  components: {
    CalendarIcon
  },
  props: {
    creditCount: {
      type: Number,
      default: 0
    },
    date: {
      type: String,
      default: ''
    },
    isDaily: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    displayDate () {
      const dateStr = this.date
      if (this.isDaily) {
        return moment(dateStr).format('MMMM D')
      }
      return moment(dateStr).format('YYYY MMMM')
    }
  }
}
</script>

<style scoped>
.tooltip {
  background-color: #101118;
  width: 206px;
}
</style>